import React, { useState, useEffect } from 'react';
import { supabase } from '../../../../lib/clients/supabase';
import './Overview.css';

const Overview = () => {
  const [statistics, setStatistics] = useState({
    totalRegisteredUsers: 0,
    totalGuestUsers: 0,
    totalRevenue: 0,
    loading: true
  });

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      setStatistics(prev => ({ ...prev, loading: true }));

      // Fetch registered users count (excluding admin)
      const { data: registeredUsers, error: registeredError } = await supabase
        .from('profiles')
        .select('id', { count: 'exact' })

      if (registeredError) throw registeredError;

      // Fetch guest users count
      const { data: guestUsers, error: guestError } = await supabase
        .from('guest_profiles')
        .select('id', { count: 'exact' });

      if (guestError) throw guestError;

      // Fetch all bookings to calculate total revenue
      const { data: bookings, error: bookingsError } = await supabase
        .from('bookings')
        .select('total_price');

      if (bookingsError) throw bookingsError;

      // Calculate total revenue
      const totalRevenue = bookings.reduce((total, booking) => total + (booking.total_price || 0), 0);

      // Update statistics
      setStatistics({
        totalRegisteredUsers: registeredUsers.length || 0,
        totalGuestUsers: guestUsers.length || 0,
        totalRevenue,
        loading: false
      });
    } catch (error) {
      console.error('Error fetching statistics:', error);
      setStatistics(prev => ({ ...prev, loading: false }));
    }
  };

  if (statistics.loading) {
    return <div className="overview__loading">Loading statistics...</div>;
  }

  return (
    <div className="overview">
      <div className="overview__stats">
        <div className="overview__stat-card overview__stat-card--users">
          <div className="stat-icon">👥</div>
          <div className="stat-info">
            <h3>Registered Users</h3>
            <p className="stat-value">{statistics.totalRegisteredUsers}</p>
          </div>
        </div>

        <div className="overview__stat-card overview__stat-card--guests">
          <div className="stat-icon">👤</div>
          <div className="stat-info">
            <h3>Guest Users</h3>
            <p className="stat-value">{statistics.totalGuestUsers}</p>
          </div>
        </div>

        <div className="overview__stat-card overview__stat-card--revenue">
          <div className="stat-icon">💰</div>
          <div className="stat-info">
            <h3>Total Revenue</h3>
            <p className="stat-value">${statistics.totalRevenue.toFixed(2)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview; 